import './remove-empty-p';
import '../styles/app.scss';
import './_images';
import './_fonts';
import './components/slider';
import './nav-controller';
import './breakpoint-controller';
import VideoPopup from "./components/video-popup";
import CarouselToggles from "./components/carousel-toggles";
import StickyMenu from "./components/sticky-menu";
import Formation from "./components/formation";
import MagnificPopup from "./components/magnificPopup";
import BoxLink from "./components/box-link";
import PersonalizeTab from "./components/personalize-tab";
import './components/acord-calculator';
import TabCard from "./components/tab-card";
import Accordeon from "./components/accordeon";
import Resources from "./components/resources";
import TabsLinkImage from "./components/tabs-link-image";
import './utils/grid';
import CertificationsTabs from "./components/certifications-tabs";
import EventsList from "./components/events-list";
import BlogsGrid from "./components/blogs-grid";
import TestimonialsGrid from "./components/testimonials-grid";
import CmsFeatures from "./components/cms-features";
import Partners from "./components/partners";
import CurrentYear from "./components/currentYear";
import StatsObserver from "./components/stats-observer";
import Podcasts from "./components/podcasts";
import CustomersTab from "./components/customer-tab";
import ContentExchangeToggle from "./components/filtering-toggle";
import PromoBar from "./components/promoBar";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		new VideoPopup();
		new TabCard();
		new Accordeon();
		new CarouselToggles();
		new StickyMenu();
		new Formation();
		new MagnificPopup();
		new BoxLink();
		new PersonalizeTab();
		new Resources();
		new TabsLinkImage();
		new CertificationsTabs();
		new EventsList();
		new BlogsGrid();
		new TestimonialsGrid();
		new CmsFeatures();
		new Partners();
		new CurrentYear();
		new StatsObserver();
		new Podcasts();
		new CustomersTab();
		new ContentExchangeToggle();
		new PromoBar();
	},
	false
);


